// extracted by mini-css-extract-plugin
export default {"errorPane":"Error_errorPane__d+9H4","title":"Error_title__hXnw-","subtitle":"Error_subtitle__s1vXD"};